import React from 'react';
import history from "../../../../libs/history";

import Icon from '../../Icon';
import EncourageSignup from "../../../components2/encourageSignup/EncourageSignup";

export default class Searchbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: (this.props.location && this.props.location.pathname && this.props.location.pathname.match("/recherche") && this.props.location.pathname.replace("/recherche/", "")) || '',
            toggleSuggestion: false,
            isFocused: false,
            togglePopup : false
        };
        this.handleSearch = this.handleSearch.bind(this);
        // this.handleAddSuggestion = this.handleAddSuggestion.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(nextProps.location && nextProps.location.pathname && this.props.location && this.props.location.pathname && nextProps.location.pathname !== this.props.location.pathname && nextProps.location.pathname.match("/recherche")){
            this.setState({search: nextProps.location.pathname.replace("/recherche/", "")})
        }
        return true;
    }

    handleSearch(event) {
        if (this.state.search.length >= 3) {
            this.setState({toggleSuggestion: true, search: event.target.value})
        } else {
            this.setState({search: event.target.value})
        }
    }

    // handleAddSuggestion(search) {
    //     if (this.focusInput !== null) {
    //         this.focusInput.focus();
    //     }
    //     this.setState({search, toggleSuggestion: false})
    // }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        if(this.props.currentUserInitialized){
            if (this.state.search.length >= 1) {
                let search = this.state.search;
                history.push(`/recherche/${search}`)
            }
        }
        else{
            this.setState({togglePopup : true});
        }


    }

    handleFocus() {
        this.setState({isFocused: !this.state.isFocused}, () => this.props.handleSearchBarDisplay(this.state.isFocused));
    }

    render() {
        return (
            <div className={`searchbar ${this.props.className} ${this.state.isFocused ? 'active' : ''}`}>
                <div className="search-icon">
                    <Icon type="search"/>
                </div>
                <EncourageSignup toggle={this.state.togglePopup} handleClose={() => this.setState({togglePopup: false})} />
                <form onSubmit={this.handleSubmit}
                >
                    <input
                        className="search-bar"
                        type="text"
                        placeholder={`${this.props.isMobile ? 'Faire une recherche ...' : 'Rechercher un Voissanaute'}`}
                        value={this.state.search}
                        onChange={(event) => this.handleSearch(event)}
                        onFocus={() => this.handleFocus()}
                        onBlur={() => this.handleFocus()}
                        ref={(ref) => this.focusInput = ref}
                    />
                </form>
                {
                    //   this.state.toggleSuggestion && this.state.search.length >= 4 && (
                    //   <div className="suggestions-group">
                    //     <SuggestionSearch
                    //       infos="test"
                    //       handleAddSuggestion={this.handleAddSuggestion}
                    //     />
                    //     <SuggestionSearch
                    //       infos="test 2"
                    //       handleAddSuggestion={this.handleAddSuggestion}
                    //     />
                    //     <SuggestionSearch
                    //       infos="test 3"
                    //       handleAddSuggestion={this.handleAddSuggestion}
                    //     />
                    //     <SuggestionSearch
                    //       infos="test 4"
                    //       handleAddSuggestion={this.handleAddSuggestion}
                    //     />
                    //   </div>
                    // )
                }
            </div>
        )
    }
}
